import generateContext, { createAction } from '..';

interface IAccordionState {
  activeAccordionReferance: string;
  hoveredOrderReference: string;
}

const initialState: IAccordionState = {
  activeAccordionReferance: '',
  hoveredOrderReference: '',
};

enum AccordionActionType {
  SetActiveAccordion = 'SET_ACTIVE_ACCORDION',
  SetHoveredOrder = 'SET_HOVERED_ORDER',
  FlushHoveredOrder = 'FLUSH_HOVERED_ORDER',
}

const reducer = (
  state: IAccordionState,
  action: { type: AccordionActionType; payload?: any }
): IAccordionState => {
  switch (action.type) {
    case AccordionActionType.SetActiveAccordion:
      return {
        ...state,
        activeAccordionReferance: action.payload,
      };

    case AccordionActionType.SetHoveredOrder:
      return {
        ...state,
        hoveredOrderReference: action.payload,
      };

    case AccordionActionType.FlushHoveredOrder:
      return {
        ...state,
        hoveredOrderReference: '',
      };

    default:
      return state;
  }
};

const [AccordionCtxProvider, useAccordionState, useAccordionDispatch] =
  generateContext(reducer, initialState);

const useAccordionActions = () => {
  const dispatch = useAccordionDispatch();

  const setActiveAccordion = (payload: string) => {
    dispatch(createAction(AccordionActionType.SetActiveAccordion, payload));
  };

  const setHoveredOrder = (payload: string) => {
    dispatch(createAction(AccordionActionType.SetHoveredOrder, payload));
  };

  const flushHoveredOrder = () => {
    dispatch(createAction(AccordionActionType.FlushHoveredOrder));
  };

  return {
    setActiveAccordion,
    setHoveredOrder,
    flushHoveredOrder,
  };
};

export { AccordionCtxProvider, useAccordionState, useAccordionActions };
